import { useQuery, useQueryClient, useMutation } from "@tanstack/react-query";
import {
  GetCustomerLoyalty,
  GetLoyaltyTransactions,
  SendLoyaltyCardWhatsApp,
} from "../Api";
import { ServiceQueryOptions, unwrapApiResponse } from "./query_helpers";
import { DEFAULT_STALE_TIME } from "../Constant/AppConstants";

export const loyaltyQueryKeys = {
  balance: (customerId: string) => ["loyaltyBalance", customerId] as const,
  transactions: (customerId: string) =>
    ["loyaltyTransactions", customerId] as const,
};

export const invalidateLoyaltyQueries = (
  queryClient: ReturnType<typeof useQueryClient>,
  customerId?: string,
) => {
  if (customerId) {
    queryClient.invalidateQueries({
      queryKey: loyaltyQueryKeys.balance(customerId),
    });
    queryClient.invalidateQueries({
      queryKey: loyaltyQueryKeys.transactions(customerId),
    });
  } else {
    queryClient.invalidateQueries({ queryKey: ["loyaltyBalance"] });
    queryClient.invalidateQueries({ queryKey: ["loyaltyTransactions"] });
  }
};

export const useCustomerLoyaltyQuery = (
  customerId: string,
  options?: ServiceQueryOptions,
) => {
  return useQuery({
    staleTime: DEFAULT_STALE_TIME,
    ...options,
    queryKey: loyaltyQueryKeys.balance(customerId),
    queryFn: async () =>
      unwrapApiResponse(await GetCustomerLoyalty(customerId)),
  });
};

export const useSendLoyaltyCardWhatsApp = () => {
  return useMutation({
    mutationFn: async (customerId: string) =>
      unwrapApiResponse(await SendLoyaltyCardWhatsApp(customerId)),
  });
};

export const useLoyaltyTransactionsQuery = (
  customerId: string,
  limit = 50,
  options?: ServiceQueryOptions,
) => {
  return useQuery({
    staleTime: DEFAULT_STALE_TIME,
    ...options,
    queryKey: loyaltyQueryKeys.transactions(customerId),
    queryFn: async () =>
      unwrapApiResponse(await GetLoyaltyTransactions(customerId, limit)) ?? [],
  });
};
